import { render, staticRenderFns } from "./Freespins.vue?vue&type=template&id=67da3e76&scoped=true&"
import script from "./Freespins.vue?vue&type=script&lang=js&"
export * from "./Freespins.vue?vue&type=script&lang=js&"
import style0 from "./Freespins.vue?vue&type=style&index=0&id=67da3e76&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67da3e76",
  null
  
)

export default component.exports